import loadable from '@loadable/component'

import {
  APPLE_CALLBACK_PATH,
  DELETE_ACCOUNT_PATH,
  LINE_CALLBACK_PATH,
  RECHARGE_PATH,
  X_CALLBACK_PATH,
} from '~/utils/constant'

const OauthCallbackPage = loadable(
  () =>
    import(
      /* webpackChunkName: "page-oauth-callback" */ '~/pages/oauthCallback'
    )
)

const routes = [
  {
    path: '/',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-homepage" */ '~/pages/homepage')
    ),
  },
  {
    path: '/callApp',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-callApp" */ '~/pages/callApp')
    ),
  },
  {
    path: RECHARGE_PATH,
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-recharge" */ '~/pages/recharge')
    ),
  },
  {
    path: DELETE_ACCOUNT_PATH,
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-delete-account" */ '~/pages/deleteAccount'
        )
    ),
  },
  {
    path: LINE_CALLBACK_PATH,
    exact: true,
    component: OauthCallbackPage,
  },
  {
    path: APPLE_CALLBACK_PATH,
    exact: true,
    component: OauthCallbackPage,
  },
  {
    path: X_CALLBACK_PATH,
    exact: true,
    component: OauthCallbackPage,
  },
  {
    path: '',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '~/pages/notFound')
    ),
  },
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => routes
